import { GridSortModel } from "@mui/x-data-grid-pro";
import { SortItem } from "@custom-types/sort-types";

type SortOptions<TSortField extends string, TSortBy> = {
  /** Default sort by value */
  defaultSortBy: TSortBy;

  /** Check function if a field is a valid sort field */
  isValidSortField: (field: string) => field is TSortField;

  /** Converts a SortItem to a sortBy value */
  getSortBy: (sortItem: SortItem<TSortField>) => TSortBy;
};

/**
 * Helper function to convert a GridSortModel to a sortBy value
 * @returns A valid sortBy value
 */
export function convertGridSortModelToSortBy<
  TSortField extends string,
  TSortBy
>(
  gridSortModel: GridSortModel,
  options: SortOptions<TSortField, TSortBy>
): TSortBy {
  // The columns definition of the table ensures that there is only one
  // sort item at the time, but since GridSortModel is always an array of sort items
  // then simply take the first item in the array.
  const gridSortItem = gridSortModel[0];

  if (
    !gridSortItem ||
    !gridSortItem.field ||
    typeof gridSortItem.field !== "string" ||
    !gridSortItem.sort ||
    !options.isValidSortField(gridSortItem.field)
  ) {
    return options.defaultSortBy;
  }

  return options.getSortBy({
    field: gridSortItem.field,
    sort: gridSortItem.sort,
  });
}
